<wf-page-tour [steps]="tourSteps"></wf-page-tour>
<wf-main-content categoryName="Enroll" [categoryIcon]="enrollIcon" toolName="Student Subscriptions">
  @if (user()?.userRole === UserRoles.SCHOOL_ADMIN || user()?.effectiveUserRole === UserRoles.SCHOOL_ADMIN || user()?.userRole === UserRoles.CUSTOMER_SERVICE) {
    <div class="tool-scope">
      <div class="filter-options">
        <wf-school-teacher-filter
          class="manage-subscriptions-school-teacher-filter"
          [districts]="districts"
          [teachers]="teachers"
          [chainLoad]="user()?.userRole === UserRoles.CUSTOMER_SERVICE"
          [includeAllScope]="true"
          [padding]="false"
          (filterChangeEvent)="schoolTeacherFilters.set($event)"
        />
        <wf-students-filter
          [grades]="screenerData()?.grades ?? []"
          [filterClass]="false"
          [filterExtraSupport]="false"
          [emitOnNewData]="true"
          (filterChangeEvent)="filters.set($event)"
        />
      </div>
    </div>
  }
  <div class="manage-student-subscriptions">
    <!-- <div [ngClass]="{ 'disabled-report' : schoolFilterError }"></div> -->
    <div class="manage-subscriptions-info">
      <div class="manage-subscriptions-summary">
        <div class="manage-subscriptions-count-summary">
          <h3 id="resultsTableHeader" class="screener-header bold">
            Subscriptions
          </h3>
          @if(showDiagnosticSubscriptions()) {
            <div class="manage-subscriptions-type-select">
              <div>
                <input type="radio" id="diagnostic-radio" value="diagnostic" [(ngModel)]="subscriptionType">
                <label for="diagnostic-radio">Diagnostic</label>
              </div>
              <div>
                <input type="radio" id="system-radio" value="system" [(ngModel)]="subscriptionType">
                <label for="system-radio">System</label>
              </div>
            </div>
          }
          @let subs = subscriptions();
          @if(subs) {
            @let diff = subscriptionDiff();
            @let remaining = subscriptionType() === "diagnostic" ? subs.remaining.diagnostic : subs.remaining.system;
            @let unlimited = remaining === -1;
            <!-- only valid if not unlimited -->
            @let diffNet = diff.remove.length - diff.add.length;
            @let unsavedRemainingSubs = remaining + diffNet;

            @if (
              user()?.userRole === UserRoles.CUSTOMER_SERVICE
              || user()?.userRole === UserRoles.SCHOOL_ADMIN
              || user()?.effectiveUserRole === UserRoles.SCHOOL_ADMIN
            ) {
              @let summary = subs.summaries?.[subscriptionType()];
              @if (summary) {
                <wf-subscription-summary
                  editing="student"
                  [subscriptionsType]="subscriptionType()"
                  [summary]="summary"
                  [editTotal]="-diffNet"
                />
              }
            } @else {
              <wf-remaining-subscriptions
                [subscriptionsType]="subscriptionType()"
                [unlimited]="unlimited"
                [remaining]="unsavedRemainingSubs"
              />
            }

            <div class="save-actions">
              @let invalid = !unlimited && unsavedRemainingSubs < 0;
              <div class="manage-subscription-button-group">
                @if (allAssignableStudentsSelected()) {
                  <button type="button" class="btn btn-standard" (click)="selectNone()">Select None</button>
                } @else {
                  <button type="button" class="btn btn-standard" (click)="selectAll()">Select All</button>
                }
                <button type="button" class="btn btn-standard" (click)="resetSelection()">Reset</button>
                <button
                  type="button"
                  class="btn btn-primary"
                  [disabled]="(diff.add.length === 0 && diff.remove.length === 0) || invalid"
                  (click)="save()"
                >
                  Save
                </button>
              </div>
            </div>
            @if (invalid) {
              <wf-alert level="danger">
                You have selected {{ unsavedRemainingSubs | abs }} too many subscriptions
              </wf-alert>
            }
          }
        </div>
        <div class="screener-report">
          <h3 id="resultsTableHeader" class="screener-header bold"n>
            Screener Results
          </h3>
          <wf-screener-results [grade]="filters().grade" [students]="studentsFilteredDisplay()"/>
        </div>
        <div class="status-overview">
          <h3 id="statusOverviewHeader" class="screener-header bold">
            Status Overview
          </h3>
          <div class="status-overview-row">
            <span class="status-overview-number status-overview-number-not-started">{{ studentsNotStarted() }}</span>
            <span class="status-overview-label">Not Started ({{ notStartedPercentage() }}%)</span>
          </div>
          <div class="status-overview-row">
            <span class="status-overview-number status-overview-number-started">{{ studentsStarted() }}</span>
            <span class="status-overview-label">Started  ({{ startedPercentage() }}%)</span>
          </div>
          <div class="status-overview-row">
            <span class="status-overview-number status-overview-number-skipped">{{ studentsSkipped() }}</span>
            <span class="status-overview-label">Skipped  ({{ skippedPercentage() }}%)</span>
          </div>
          <span class="status-overview-row-border"></span>
          <div class="status-overview-row">
            <span class="status-overview-number status-overview-number-total">{{ studentsFiltered().length }}</span>
            <span class="status-overview-label bold">Total Students</span>
          </div>
        </div>
      </div>
      @if(saveError()) {
        <wf-alert
          level="danger"
          [controlledBy]="saveError"
        >
          There was an error saving subscriptions. Please refresh the page and try again or contact support.
        </wf-alert>
      }
    </div>
      <div class="scrollable-container">
        <table class="report-table subscription-table">
          <colgroup>
            <col style="width: 150px"/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
            <col/>
          </colgroup>
          <thead>
          <ng-template #sortableTableHeader let-column="column">
            <th class="sortable-report-table-header">
              <button
                (click)="updateSort(column)"
                [attr.aria-sort]="sortColumn().column === column ? (sortColumn().reverse ? 'desending' : 'ascending') : undefined"
              >
                {{ column }}
                <div
                  [class]=" { 'arrow-up' : !sortColumn().reverse, 'arrow-down': sortColumn().reverse }"
                  [style.visibility]="(sortColumn().column !== column) ? 'hidden' : 'visible'"
                  class="print-hide"
                ></div>
              </button>
            </th>
          </ng-template>
          <tr>
            <th>
              <div class="subscription-type-header">
                @if (subscriptionType() === "diagnostic") {
                  Diagnostic
                } @else {
                  System
                }
                <wf-tooltip>
                  A lock indicates that the student has a subscription assigned, has started the program, and can no longer have their subscription removed.
                </wf-tooltip>
              </div>
            </th>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.STUDENT_NAME }"/>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.GRADE }"/>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.SCREENER_SCORE }"/>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.SCREENER_STARTED }"/>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.SCREENER_COMPLETED }"/>
            <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COLUMNS.SCREENER_PERCENT_COMPLETE }"/>
          </tr>
          </thead>
          <tbody>
            @for (student of studentsFilteredDisplaySorted(); track student.userID) {
              <tr>
                @let diagnosticSub = subscriptions()?.students?.[student.userID]?.diagnostic;
                @let diagnosticChecked = selectedStudentUserIDs().diagnostic[student.userID];
                @let systemSub = subscriptions()?.students?.[student.userID]?.system;
                @let systemChecked = selectedStudentUserIDs().system[student.userID];
                <td>
                  @if (subscriptionType() === 'diagnostic') {
                    <!-- if student already has a system sub they shouldn't be able to get a diagnostic -->
                    @if (diagnosticSub?.consumed || systemSub || !(student.assessments | allAssessmentsCompleted)) {
                      <fa-icon [icon]="lockIcon"/>
                    } @else {
                      <input
                        type="checkbox"
                        class="checkbox-md"
                        (change)="toggleSub('diagnostic', student)"
                        [checked]="diagnosticChecked"
                      />
                    }
                  } @else {
                    @if (systemSub?.consumed) {
                      <fa-icon [icon]="lockIcon"/>
                    } @else {
                      <input
                        type="checkbox"
                        class="checkbox-md"
                        (change)="toggleSub('system', student)"
                        [checked]="systemChecked"
                      />
                    }
                  }
                </td>
                <th scope="row"> {{ student.firstName }} {{ student.lastName }} </th>
                <td> {{ student.grade | displayGrade }} </td>
                <td>
                  <div class="screener-results-score" [class]="student.screenerClass">
                    @if (student.firstAssessmentScore?.dateCompleted) {
                      {{ student.scoreRange }}
                    }
                  </div>
                </td>
                <td> {{ student.firstAssessmentScore?.dateStarted | date : DATE_FORMAT }} </td>
                <td> {{ student.firstAssessmentScore?.dateCompleted | date : DATE_FORMAT }} </td>
                <td>
                  @if (student.skipped) {
                    <div class="status-skipped">SKIPPED</div>
                  } @else {
                    {{ student.percentComplete | percentRound }}
                  }
                </td>
              <tr>
            }
          </tbody>
        </table>
      </div>
  </div>
</wf-main-content>
